import React from 'react';

/**
 * ArrowheadDefs Component
 * 
 * SVG marker definitions for arrowheads used on edges.
 * Branch edges use dynamic colors via stroke, so we only need generic markers.
 */
const ArrowheadDefs = () => (
  <defs>
    {/* Default arrowhead */}
    <marker
      id="arrowhead"
      markerWidth="8"
      markerHeight="6"
      refX="7"
      refY="3"
      orient="auto"
    >
      <polygon points="0 0, 8 3, 0 6" fill="rgba(255, 255, 255, 0.7)" />
    </marker>
    
    {/* Selected state arrowhead */}
    <marker
      id="arrowhead-selected"
      markerWidth="8"
      markerHeight="6"
      refX="7"
      refY="3"
      orient="auto"
    >
      <polygon points="0 0, 8 3, 0 6" fill="#ef4444" />
    </marker>
    
    {/* Muted arrowhead */}
    <marker
      id="arrowhead-muted"
      markerWidth="8"
      markerHeight="6"
      refX="7"
      refY="3"
      orient="auto"
    >
      <polygon points="0 0, 8 3, 0 6" fill="rgba(255, 255, 255, 0.4)" />
    </marker>
    
    {/* Blocking state arrowhead */}
    <marker
      id="arrowhead-blocking"
      markerWidth="8"
      markerHeight="6"
      refX="7"
      refY="3"
      orient="auto"
    >
      <polygon points="0 0, 8 3, 0 6" fill="rgba(255, 255, 255, 0.35)" />
    </marker>

    {/* Milestone gating edges */}
    <marker
      id="arrowhead-milestone"
      markerWidth="8"
      markerHeight="6"
      refX="7"
      refY="3"
      orient="auto"
    >
      <polygon points="0 0, 8 3, 0 6" fill="#a78bfa" />
    </marker>

    <marker
      id="arrowhead-milestone-blocking"
      markerWidth="8"
      markerHeight="6"
      refX="7"
      refY="3"
      orient="auto"
    >
      <polygon points="0 0, 8 3, 0 6" fill="rgba(167, 139, 250, 0.45)" />
    </marker>
  </defs>
);

export default ArrowheadDefs;

